/* eslint-disable react/no-array-index-key */
import { DATE_FORMAT_WITH_TIME } from 'constants/defaultConstants';
import { format } from 'date-fns';
import { useTranslate } from 'hooks/useTranslate';
import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';
import { FC } from 'react';
import { CustomMovement } from 'types';

type PartnerCustomMovementsSectionProps = {
  customMovements?: CustomMovement[];
};

const PartnerCustomMovementsSection: FC<PartnerCustomMovementsSectionProps> = ({
  customMovements,
}) => {
  const { t } = useTranslate();

  return (
    <section className="partner-investment-wrapper mb-5">
      <div className="nk-block-head">
        <div className="nk-block-between d-flex flex-column flex-md-row">
          <div className="nk-block-head-content">
            <h4 className="nk-block-title">{t('CustomMovements')}</h4>
            <div className="nk-block-des">
              <p>{t('CustomMovementsPartnerTabDescription')}</p>
            </div>
          </div>

          <div className="nk-block-head-content">
            <div className="nk-block float-right">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {}}
                disabled
              >
                <em className="icon ni ni-plus mr-1" />
                {t('AddCustomMovement')}
              </button>
            </div>
          </div>
        </div>

        <div className="card card-bordered card-preview mt-4">
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col" className="w-200px">
                  {t('Date')}
                </th>
                <th scope="col">{t('Code')}</th>
                <th scope="col">{t('Description')}</th>
              </tr>
            </thead>

            <tbody>
              {customMovements?.length ? (
                customMovements?.map((item: CustomMovement, index: number) => (
                  <tr key={`note-row-${index}`}>
                    <td className="w-200px">
                      {format(new Date(item.date), DATE_FORMAT_WITH_TIME)}
                    </td>
                    <td>{item.code}</td>
                    <td>{item.description}</td>
                  </tr>
                ))
              ) : (
                <EmptyStateForTable
                  colspan={3}
                  mainMessage={t('NoCustomMovements')}
                  infoMessage=""
                />
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default PartnerCustomMovementsSection;
